/**
 * Input Schema of Faturamento
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import {FaturamentoConfiguracao} from '@/model/resource/FaturamentoConfiguracao'
import SearchResponsavel from '@/components/SearchResponsavel.vue'

export class InputFaturamentoSchema extends Schema {
  collectionResponsavel = new ResponsavelCollection().noPagination()

  formFields = [
    'diaInicial',
    'diaFinal',
    'dataVencimentoContrato',
    'dataUltimaCorrecao',
    'numeroProtheus',
    'observacao',
  ]

  formFieldsValues = [
    'valorIroute',
    'valorCheckinAutomatico',
    'valorExibirMapaSacPainel',
    'valorBi',
    'valorNotificacaoSMS',
    'valorVoip',
    'valorTorreControle',
    'valorNotificacaoWhatsup',
    'valorAcessoLimitadoTransportadores',
    'valorCheckList',
    'valorConsultaPedido',
    'valorContraSenha',
  ]

  formFieldsFlags = ['ehGrupoEconomico', 'ativo']

  readonly name = 'InputFaturamentoConfiguracao'

  readonly fieldSet: FieldSet<FaturamentoConfiguracao> = {
    responsavel: (schema): FieldComponent => ({
      is: SearchResponsavel,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'col-span-2',
        collection: this.collectionResponsavel,
        noResultLabel: this.translateFrom('noResultLabel'),
        noOptionsLabel: this.translateFrom('noOptionsLabel'),
        required: true,
      },
    }),
    diaInicial: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'number',
        min: 1,
        max: 31,
        label: this.translateFrom(schema.fieldName),
        required: true,
      },
    }),
    diaFinal: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'number',
        min: 1,
        max: 31,
        label: this.translateFrom(schema.fieldName),
        required: true,
      },
    }),
    dataVencimentoContrato: (schema): FieldComponent => ({
      is: Component.InputDate,
      bind: {
        label: this.translateFrom(schema.fieldName),
      },
    }),
    dataUltimaCorrecao: (schema): FieldComponent => ({
      is: Component.InputDate,
      bind: {
        label: this.translateFrom(schema.fieldName),
      },
    }),
    numeroProtheus: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'number',
        length: 15,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    observacao: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 1000,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    valorIroute: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        content: schema.model.valorIroute,
        type: 'currency',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    valorBi: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        content: schema.model.valorBi,
        type: 'currency',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    valorTorreControle: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        content: schema.model.valorTorreControle,
        type: 'currency',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    valorAcessoLimitadoTransportadores: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        content: schema.model.valorAcessoLimitadoTransportadores,
        type: 'currency',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    valorConsultaPedido: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        content: schema.model.valorConsultaPedido,
        type: 'currency',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    valorCheckinAutomatico: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        content: schema.model.valorCheckinAutomatico,
        type: 'currency',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    valorNotificacaoSMS: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        content: schema.model.valorNotificacaoSMS,
        type: 'currency',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    valorNotificacaoWhatsup: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        content: schema.model.valorNotificacaoWhatsup,
        type: 'currency',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    valorCheckList: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        content: schema.model.valorCheckList,
        type: 'currency',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    valorContraSenha: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        content: schema.model.valorContraSenha,
        type: 'currency',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    valorExibirMapaSacPainel: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        content: schema.model.valorExibirMapaSacPainel,
        type: 'currency',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    valorVoip: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        content: schema.model.valorVoip,
        type: 'currency',
        label: this.translateFrom(schema.fieldName),
      },
    }),
    ehGrupoEconomico: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8 col-span-2',
        labelClass: 'relative state',
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
